import { render, staticRenderFns } from "./lunch.vue?vue&type=template&id=67b31214&scoped=true"
import script from "./lunch.vue?vue&type=script&lang=js"
export * from "./lunch.vue?vue&type=script&lang=js"
import style0 from "./lunch.vue?vue&type=style&index=0&id=67b31214&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b31214",
  null
  
)

export default component.exports